import axios from "axios";
import { GET_IP_ADDRESS } from "../../apiConst";
const baseUrl =
  window.location.hostname === "localhost"
    ? process.env.REACT_APP_LOCAL_BASE_URL
    : process.env.REACT_APP_BASE_URL;

axios.interceptors.request.use(
  function (config) {
    if (config.url !== GET_IP_ADDRESS)
      config.headers.token = localStorage.getItem("userAuthToken");
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export const getRequest = (url, params, config = {}) =>
  axios
    .get(baseUrl + url, { ...config, params })
    .then((response) => {
      if (response?.data?.status === 400 || response?.data?.status === 500) {
        handleError(response);
      } else {
        console.log(response);
        return response.data;
      }
    })
    .catch((error) => handleError(error));

export const postRequest = (url, payload, config = {}, params) =>
  axios
    .post(baseUrl + url, payload, { ...config, params })
    .then((response) => {
      const { status } = response.data;
      if (status === 400 || status === 500) {
        handleError(response);
      } else {
        return response;
      }
    })
    .catch((error) => {
      return handleError(error);
    });

export const putRequest = (url, payload, config = {}, params) =>
  axios
    .put(baseUrl + url, payload, { ...config, params })
    .then((response) => {
      if (response.data.status === 200) {
        return response;
      } else {
        handleError(response);
      }
    })
    .catch((error) => {
      return handleError(error);
    });

export const deleteRequest = (url, payload, config = {}, params) =>
  axios
    .delete(baseUrl + url, { data: payload }, { ...config, params })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return handleError(error);
    });

export const handleError = (error) => {
  console.log(error);
  if (
    error?.response?.data &&
    (error.response.data.status === 401 ||
      error.response.data.status === 400 ||
      error.response.data.status === 500)
  ) {
    localStorage.removeItem("userAuthToken");
    localStorage.removeItem("locationIp");
    window.location.reload();
  }
  throw error;
};
